<template>
  <AppDialog
    :show="show"
    :title="title"
    append-to-body
    class="smart-notifications-dialog smart-notifications-type-dialog"
    @close="emitClose"
  >
    <div class="notification-type">
      <section class="notification-type-cards">
        <div
          class="custom-type card d-flex align-items-center flex-column justify-content-center"
          @click="emitType('notification')"
        >
          <img
            :src="ICON_BELL_RINGING"
            class="hi-24 mb-10"
          />
          <span>Create a custom notification</span>
        </div>
        <div
          class="card d-flex align-items-center flex-column justify-content-center"
          @click="emitType('templates')"
        >
          <i class="icon hi hi-apps hi-24 mb-10" />
          <span>Choose from our templates</span>
        </div>
      </section>
      <div class="action-buttons mt-30">
        <AppButton @click.stop="emitClose">Close</AppButton>
      </div>
    </div>
  </AppDialog>
</template>

<script>
import { ICON_BELL_RINGING } from '~/rails_assets';
import { SETTINGS_SMART_NOTIFICATIONS } from '~/app_constants';

export default {
  name: 'SmartNotificationsChooseTypeDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    ICON_BELL_RINGING,
  }),
  computed: {
    title() {
      return SETTINGS_SMART_NOTIFICATIONS.copy.template_dialog.title;
    },
    description() {
      return SETTINGS_SMART_NOTIFICATIONS.copy.template_dialog.description;
    },
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    emitType(dialog) {
      this.$emit('chooseType', dialog);
    },
  },
};
</script>
